/**
 * Resolve a browser-safe image URL from optional signed URL + raw DB path.
 * - Signed / absolute URLs pass through.
 * - Legacy uploads/... map to site-relative /uploads/...
 * - Cloud storage keys like profiles/10/uuid.jpeg are not valid on the app origin; return null
 *   unless a signed URL is provided.
 */
export function resolveProfileImageSrc(signedOrAbsoluteUrl, rawPath) {
  if (signedOrAbsoluteUrl) {
    const u = String(signedOrAbsoluteUrl).trim();
    // Never treat legacy mistaken "URL" as valid (would hit API origin /profiles/...)
    if (!u.startsWith('/profiles/')) return u;
  }
  if (!rawPath) return null;
  const s = String(rawPath).trim();
  if (s.startsWith('http://') || s.startsWith('https://')) return s;
  if (s.startsWith('/uploads/') || s.startsWith('uploads/')) {
    return s.startsWith('/') ? s : `/${s}`;
  }
  if (s.startsWith('profiles/') || s.startsWith('/profiles/')) {
    return null;
  }
  if (s.startsWith('/')) return s;
  return `/${s}`;
}

/**
 * Resolve a displayable avatar URL for a user-like object.
 * Prefer profile_image_url (e.g. signed cloud URL) when provided by the API.
 */
export function userAvatarSrc(user) {
  if (!user) return null;
  return resolveProfileImageSrc(user.profile_image_url, user.profile_image);
}
